import * as React from 'react'
import {
  Button,
  Checkbox,
  Container,
  FormControlLabel,
  FormHelperText,
} from '@mui/material'
import '../styles/login.scss'
import GoogleLogo from '../assets/imgs/google-logo.svg'
import FacebookLogo from '../assets/imgs/facebook-logo.svg'
import TwitterLogo from '../assets/imgs/twitter-logo.svg'
import PhoneImage from '../assets/imgs/Phone.png'
import AppStoreBadge from '../assets/imgs/app-store-badge.png'
import { Link, useNavigate } from 'react-router-dom'
import CustomInput from './styled/CustomInput.styled'
import { Col, Row } from 'react-bootstrap'
import GooglePlayBadge from '../assets/imgs/google-play-badge.png'
import ResetPasswordModal from '../components/Modal'
import { useDispatch } from 'react-redux'
import { setUser } from '../app/features/user/userSlice'
import LoginBackgroundImage from '../assets/imgs/background-image.svg'
import CheckboxUnchecked from '../assets/imgs/unchecked-checkbox.svg'
import CheckboxChecked from '../assets/imgs/checked-checkbox.svg'
import { useState } from 'react'
import { login } from '../apis/userApis'
import Swal from 'sweetalert2/dist/sweetalert2'
import IconButton from '@mui/material/IconButton';
import {
  GoogleLogin,
  useGoogleLogin,
  useGoogleLogout,
} from 'react-google-login'
import { gapi } from 'gapi-script'
import { saveOrUpdateDataById } from '../apis/generalApis'
// import FacebookLogin from 'react-facebook-login';
import FacebookLogin from 'react-facebook-login/dist/facebook-login-render-props'
import { ScaleLoader } from 'react-spinners'
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputAdornment from '@mui/material/InputAdornment';
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

function Login() {
  const navigate = useNavigate()
  const [isLoading, setIsLoading] = useState(false)
  const [rememberMe, setRememberMe] = useState(false)
  const [showPassword, setShowPassword] = useState(false)
  const [resetPasswordModal, setResetPasswordModal] = React.useState(false)
  const clientId =
    '797918827353-g46btpn4ubrlselp85mrffuhnd5fhocf.apps.googleusercontent.com'
  const handleResetPasswordModal = (toggleModal) =>
    setResetPasswordModal(toggleModal)
  const dispatch = useDispatch()
  const [alert, setAlert] = useState({
    success: false,
    error: false,
    errorMessage: '',
  })

  React.useEffect(() => {
    const initClient = () => {
      gapi.client.init({
        clientId: clientId,
        scope: '',
      })
    }
    gapi.load('client:auth2', initClient)
  }, [])

  const loginUser = async () => {
    if (state.email !== '' && state.password !== '') {
      let body = {
        email: state.email,
        password: state.password,
        Remember: rememberMe,
      }
      setIsLoading(true)
      let result = await login('user-login', body)
      setIsLoading(false)
      if (result?.success !== false && result?.data != null) {
        localStorage.setItem('user', JSON.stringify(result?.data))
        dispatch(setUser({ user: result?.data }))
        if (result?.data != null && result?.data.user_type === 'client') {
          navigate('/home')
        } else if (
          result?.data != null &&
          result?.data?.user_type === 'provider'
        ) {
          navigate('/dashboard')
        }
      } else if (result?.success === false) {
        Swal.fire({
          icon: 'error',
          title: result?.message,
          text: 'Please try again!',
          timer: 3000,
          confirmButtonColor: '#2597F6',
        })
      }
      setIsLoading(false)
    }
  }

  const onSuccess = async (res) => {
    // console.log('success:', res)
    let result = await saveOrUpdateDataById('google-login', {
      access_token: res.accessToken,
      email: res.profileObj.email,
      first_name: res.profileObj.givenName,
      last_name: res.profileObj.familyName,
      profile_image: res.profileObj.imageUrl,
    })
    if (result?.success === true) {
      localStorage.setItem('user', JSON.stringify(result?.user))
      navigate('/home')
    }
  }

  const facebookLogin = (data) => {
    // console.log({ data })
  }

  const onFailure = (err) => {
    // console.log('failed:', err)
  }

  const responseFacebook = async (response) => {
    // console.log(response)
    let result = await saveOrUpdateDataById('')
  }

  const [state, setState] = useState({
    email: '',
    password: '',
  })

  const handleChange = (e) => {
    setState({ ...state, [`${e.target.name}`]: e.target.value })
  }

  const { signIn } = useGoogleLogin({
    onSuccess,
    onFailure,
    clientId,
  })

  return (
    <Container>
      <ScaleLoader
        color="#36d7b7"
        loading={isLoading}
        style={{
          position: 'fixed',
          left: 0,
          right: 0,
          height: '100%',
          top: 0,
          display: 'flex',
          zIndex: 9,
          justifyContent: 'center',
          alignItems: 'center',
          backdropFilter: 'blur(10px)',
          background: '#ffffff00 0% 0% no-repeat padding-box',
        }}
      />
      <div className="row">
        <div
          className="d-none d-sm-none d-md-block col-md-6 d-flex justify-content-center align-items-center position-relative p-0"
          style={{
            height: '80vh',
          }}
        >
          <div className="login-phone-image">
            <img src={PhoneImage} alt="" height={'100%'} />
          </div>
          <div className="backgoundImageWrapper">
            <img src={LoginBackgroundImage} alt="" />
          </div>
          <Row className="download-app-btn-section position-absolute">
            <Col md={6}>
              <p className="getAllServicesText">
                Get all the services at your fingertips
              </p>
              <h3
                className="downloadText fs-32 fw-bold color-primary m-0 mt-2 lh-1"
                style={{ color: '#2597F6' }}
              >
                Download our app now!!
              </h3>
            </Col>
            <Col md={6}>
              <div className="d-flex justify-content-evenly align-items-center flex-column h-100">
                <a
                  href="https://play.google.com/store/games?hl=en&gl=US"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img src={GooglePlayBadge} alt="" height="34" width={113} />
                </a>
                <a
                  href="https://www.apple.com/app-store/"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img src={AppStoreBadge} alt="" height="34" width={113} />
                </a>
              </div>
            </Col>
          </Row>
        </div>
        <div className="col-12 col-sm-12 col-md-6 d-flex align-items-center justify-content-center flex-column formWrapper">
          <div className="text-center loginFormWrapper">
            <h3 className="loginHeading">Log in to your Account</h3>
            <FormHelperText id="input-label" className="mt-4" margin="dense">
              Email
            </FormHelperText>
            <CustomInput
              margin="dense"
              placeholder="janedoe@email.com"
              name="email"
              value={state.email}
              id="email"
              fullWidth={true}
              type="email"
              required
              onChange={(e) => handleChange(e)}
            />
            <FormHelperText id="input-label" margin="dense" className="mt-3">
              Password
            </FormHelperText>
            <OutlinedInput
              id="password"
              fullWidth={true}
              margin="dense"
              required
              name="password"
              value={state.password}
              placeholder="••••••••••••"
              onChange={(e) => handleChange(e)}
              type={showPassword ? 'text' : 'password'}
              endAdornment={
               <InputAdornment position="end">
                <IconButton
                  aria-label="toggle password visibility"
                  onClick={() => setShowPassword(prev => !prev)}
                  edge="end"
                >
                  {showPassword ? <VisibilityOff sx={{width: '1rem'}} /> : <Visibility sx={{width: '1rem'}} />}
                </IconButton>
              </InputAdornment>
            }
            label="Password"
          />
            <div className="d-flex justify-content-between align-items-center my-3 mx-0 gap-2">
              <FormControlLabel
                className="fs-10 gap-1"
                checked={rememberMe}
                onChange={(e) => setRememberMe(e.target.checked)}
                control={
                  <Checkbox
                    sx={{ padding: 0, height: '1.7rem', marginLeft: '10px' }}
                    checkedIcon={
                      <CheckCircleIcon sx={{color: "#08C4BB", width: '1rem'}} />
                    }
                    icon={
                      <RadioButtonUncheckedIcon sx={{color: "#08C4BB", width: '1rem'}} />
                    }
                  />
                }
                label={<p className="fs-12 font-weight-bold">Remember Me</p>}
              />
              <p
                className="m-0 pointer fs-12 font-weight-bold"
                onClick={() => handleResetPasswordModal(true)}
              >
                Forgot Password?
              </p>
            </div>
            <ResetPasswordModal
              handleResetPasswordModal={handleResetPasswordModal}
              modalOpen={resetPasswordModal}
            ></ResetPasswordModal>
            <Button
              disableElevation
              id="btn-primary"
              variant="contained"
              disabled={isLoading}
              fullWidth={true}
              onClick={loginUser}
              className="text-capitalize"
            >
              Login
            </Button>
            {/* <FacebookLogin
              appId="497666072411986"
              autoLoad={true}
              fields="name,email,picture"
              onClick={facebookLogin}
              callback={responseFacebook}
              icon={<img src={FacebookLogo} />}
            /> */}
            {/* <FacebookLogin
              appId={process.env.REACT_APP_FACEBOOK_CLIENT_ID}
              autoLoad
              callback={responseFacebook}
              render={(renderProps) => (
                <img
                  src={FacebookLogo}
                  alt="Facebook Logo"
                  height={26}
                  onClick={renderProps.onClick}
                />
                // <img src={FacebookLogo} />
              )}
            /> */}
            {/* </Link> */}
            <p className="mt-3">Or continue with</p>
            <div className="d-flex justify-content-around align-items-center my-4 mx-0">
              <img
                src={GoogleLogo}
                alt="Google Logo"
                height={26}
                className="pointer"
                onClick={signIn}
              />
              <FacebookLogin
                appId={process.env.REACT_APP_FACEBOOK_CLIENT_ID}
                autoLoad={false}
                callback={responseFacebook}
                onClick={facebookLogin}
                render={(renderProps) => (
                  <img
                    src={FacebookLogo}
                    alt="Facebook Logo"
                    height={26}
                    onClick={renderProps.onClick}
                    className="pointer"
                  />
                  // <img src={FacebookLogo} />
                )}
              />
              <img src={TwitterLogo} alt="Twitter Logo" height={26} />
            </div>
            <p className="m-0 mb-2">Don't have an account? Create now</p>
            <Link
              className="text-decoration-none sign-up-btn-wrappper"
              to="/sign-up"
            >
              <Button
                variant="outlined"
                disableElevation
                id="btn-transparent"
                fullWidth={true}
                className="text-capitalize"
              >
                Sign Up
              </Button>
            </Link>
          </div>
        </div>
      </div>
    </Container>
  )
}

export default Login
